export enum AdCreativeEnum {
  ImageOrVideoCreative = 'ImageOrVideo',
  CarouselCreative = 'Carousel'
}
